(function() {
  // FAQ accordion
  try {
    (document.querySelector('.d3x-root')||document).querySelectorAll('.faq-q').forEach(function(q) {
      q.addEventListener('click', function() {
        q.parentElement.classList.toggle('open');
      });
    });
  } catch(e) {}

  // Ingredient accordion — tap row head to toggle
  try {
    (document.querySelector('.d3x-root')||document).querySelectorAll('.ing-head').forEach(function(head) {
      head.addEventListener('click', function() {
        head.parentElement.classList.toggle('open');
      });
    });
  } catch(e) {}

  // Scroll reveal (progressive enhancement)
  try {
    if ('IntersectionObserver' in window) {
      (document.querySelector('.d3x-root')||document.body).classList.add('js-reveal');
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            e.target.classList.add('in');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -5% 0px' });
      (document.querySelector('.d3x-root')||document).querySelectorAll('.reveal').forEach(function(el) { io.observe(el); });

      // Safety net
      setTimeout(function() {
        (document.querySelector('.d3x-root')||document).querySelectorAll('.reveal:not(.in)').forEach(function(el) {
          el.classList.add('in');
        });
      }, 2500);
    }
  } catch(e) {
    (document.querySelector('.d3x-root')||document.body).classList.remove('js-reveal');
  }

  // Count-up animation for ALL elements with data-count-to
  // (works for 70% and the Meet D3X specs)
  try {
    if ('IntersectionObserver' in window) {
      var counters = (document.querySelector('.d3x-root')||document).querySelectorAll('[data-count-to]');
      // Set each counter to 0 initially (but preserve final value in data attr)
      counters.forEach(function(c) {
        var target = parseInt(c.getAttribute('data-count-to'), 10);
        if (!isNaN(target) && target > 0) c.textContent = '0';
      });

      var countIo = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          if (e.isIntersecting) {
            var el = e.target;
            var target = parseInt(el.getAttribute('data-count-to'), 10);
            if (isNaN(target)) { countIo.unobserve(el); return; }
            var duration = 1600 + Math.min(target, 2000) * 0.15; // longer for bigger nums
            var start = performance.now();
            function tick(now) {
              var p = Math.min((now - start) / duration, 1);
              var eased = 1 - Math.pow(1 - p, 3);
              el.textContent = Math.round(eased * target).toLocaleString();
              if (p < 1) requestAnimationFrame(tick);
              else el.textContent = target.toLocaleString();
            }
            requestAnimationFrame(tick);
            countIo.unobserve(el);
          }
        });
      }, { threshold: 0.4 });
      counters.forEach(function(c) { countIo.observe(c); });
    }
  } catch(e) {
    // Fallback: just show the final values
    (document.querySelector('.d3x-root')||document).querySelectorAll('[data-count-to]').forEach(function(c) {
      c.textContent = c.getAttribute('data-count-to');
    });
  }

  // Sticky CTA visibility (hide near final)
  try {
    var sticky = document.querySelector('.d3x-root #stickyCta');
    var finalEl = document.querySelector('.d3x-root .final');
    if (sticky && finalEl && 'IntersectionObserver' in window) {
      var stickyIo = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
          sticky.classList.toggle('hidden', e.isIntersecting);
        });
      }, { threshold: 0.3 });
      stickyIo.observe(finalEl);
    }
  } catch(e) {}

  // Stagger animation delays
  try {
    (document.querySelector('.d3x-root')||document).querySelectorAll('.mission-reason').forEach(function(el, i) {
      el.style.transitionDelay = (i * 0.1) + 's';
    });
  } catch(e) {}
})();